import { AGENCY_ZOOM_ORDER_VALUES } from "../search-customers/customerSearchOptions";

// `order` ("asc"/"desc") is a genuinely shared enum domain with the customer search —
// reuse the values, but keep the label keys in this node's own i18n namespace so the
// two nodes' translations don't drift together.
export const AGENCY_ZOOM_LEAD_ORDER_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_ORDER_VALUES)[number],
  string
> = {
  asc: "agencyZoomSearchLeadsSettings.orderAsc",
  desc: "agencyZoomSearchLeadsSettings.orderDesc",
};

// `sort` is enum-constrained (unlike the customer search's free-form `sort`) — values are
// camelCase field names, validated by Omega's `LiteralMustBeOneOf` at publish time.
export const AGENCY_ZOOM_LEAD_SORT_VALUES = [
  "firstname",
  "lastname",
  "lastEnterStageDate",
  "lastActivityDate",
] as const;

export const AGENCY_ZOOM_LEAD_SORT_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_LEAD_SORT_VALUES)[number],
  string
> = {
  firstname: "agencyZoomSearchLeadsSettings.sortFirstname",
  lastname: "agencyZoomSearchLeadsSettings.sortLastname",
  lastEnterStageDate: "agencyZoomSearchLeadsSettings.sortLastEnterStageDate",
  lastActivityDate: "agencyZoomSearchLeadsSettings.sortLastActivityDate",
};

// Snake_case of Omega's `LeadStatus` enum member names (mirrors `CustomerStatus`).
export const AGENCY_ZOOM_LEAD_STATUS_VALUES = [
  "new",
  "quoted",
  "won",
  "lost",
  "contacted",
  "expired",
] as const;

export const AGENCY_ZOOM_LEAD_STATUS_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_LEAD_STATUS_VALUES)[number],
  string
> = {
  new: "agencyZoomSearchLeadsSettings.statusNew",
  quoted: "agencyZoomSearchLeadsSettings.statusQuoted",
  won: "agencyZoomSearchLeadsSettings.statusWon",
  lost: "agencyZoomSearchLeadsSettings.statusLost",
  contacted: "agencyZoomSearchLeadsSettings.statusContacted",
  expired: "agencyZoomSearchLeadsSettings.statusExpired",
};

// Explicit AgencyZoom wire tokens for `LeadSoldPeriod` (forced by a type-level
// JsonStringEnumMemberName converter, independent of the surrounding naming policy).
export const AGENCY_ZOOM_LEAD_SOLD_PERIOD_VALUES = [
  "today",
  "yesterday",
  "mtd",
  "lastmonth",
  "ytd",
  "lastyear",
] as const;

export const AGENCY_ZOOM_LEAD_SOLD_PERIOD_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_LEAD_SOLD_PERIOD_VALUES)[number],
  string
> = {
  today: "agencyZoomSearchLeadsSettings.soldPeriodToday",
  yesterday: "agencyZoomSearchLeadsSettings.soldPeriodYesterday",
  mtd: "agencyZoomSearchLeadsSettings.soldPeriodMtd",
  lastmonth: "agencyZoomSearchLeadsSettings.soldPeriodLastMonth",
  ytd: "agencyZoomSearchLeadsSettings.soldPeriodYtd",
  lastyear: "agencyZoomSearchLeadsSettings.soldPeriodLastYear",
};
